<ng-container>
  <hdw-header></hdw-header>
  <router-outlet></router-outlet>
  <hdw-footer></hdw-footer>
</ng-container>
